export const PRODUCT_CHANGE_WARNING_THRESHOLD = 1;

// Count changed selections, including zero-quantity replacements. Repeated
// legacy items are deduplicated within this stop, never across other stops.
export const getStopProductChanges = (docket) => {
	const seen = new Set();
	return (docket?.productChangesPickList?.pickListItems || []).filter(item => {
		if (!item?.removedProduct?.id || item.removedProduct.id === item.product?.id || seen.has(item.id)) {
			return false;
		}
		seen.add(item.id);
		return true;
	});
};

export const getProductChangeQuantities = item => ({
	// Before service, removedProductQuantity is unset; use the pick-time estimate.
	removedQuantity: item.removedProductQuantity ?? item.planogramItemQuantity ?? 0,
	newQuantity: (item.quantity || 0) + (item.extraQuantity || 0) + (item.swapQuantity || 0),
});
